import {Breakpoint, Container } from "@mui/material";
import React from "react";

import ButtonComponent from "../button/button.component";
import {PanelTemplateComponentStyled, InlineFlexStyled, ButtonFlexStyled} from "./panel-template.component.styled";

interface ButtonsPropsType {
    text: string,
    fOnClick: () => void,
}

export type PanelTemplateComponentPropsType = {
    title: string;
    children?: React.ReactNode;
    buttons?: ButtonsPropsType[];
    contentMaxWidth?: Breakpoint; 
}

const PanelTemplateComponent = ({
    children,
    title,
    buttons,
    contentMaxWidth
}: PanelTemplateComponentPropsType) => {
    

    /** define the return statement bellow */
    return (
        <PanelTemplateComponentStyled>
            
            <Container maxWidth={contentMaxWidth ?? 'lg'}>
                <InlineFlexStyled>
                    <h3>{title}</h3>
                    <ButtonFlexStyled>
                        {buttons?.map((button, index) => (
                            <div key={index} className="button-wrapper">
                                <ButtonComponent onClick={button.fOnClick}> {button.text} </ButtonComponent>
                            </div>
                        ))}
                    </ButtonFlexStyled>
                </InlineFlexStyled>
                <div className="page-template-body">
                    {children}
                </div>
                
            </Container>  
            
        </PanelTemplateComponentStyled>
    )

}

export default PanelTemplateComponent;